"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64Encoding = exports.getMessageFromError = exports.sendTransferUpdate = exports.getSdkTransfer = exports.httpGatewaySelectFileFolderDialog = exports.handleHttpGatewayDrop = exports.createHtmlInputElement = exports.httpGetTransfer = exports.httpGetAllTransfers = exports.httpRemoveTransfer = void 0;
var messages_1 = require("../constants/messages");
var helpers_1 = require("../helpers/helpers");
var index_1 = require("../index");
var http_gateway_sdk_js_1 = require("@ibm-aspera/http-gateway-sdk-js");
/**
 * HTTP Gateway Core Logic
 * - File/Folder picking
 * - Starting and testing
 *
 * @remarks
 * Most logic is called directly by Desktop SDK functions
 * You may not need to import anything from this file.
 */
/**
 * Remove a transfer from HTTP Gateway systems
 * @param id - ID of the transfer
 *
 * @returns Promise indicating success
 */
var httpRemoveTransfer = function (id) {
    if (index_1.asperaSdk.useOldHttpGateway) {
        (0, http_gateway_sdk_js_1.removeTransfer)(id);
        return Promise.resolve({ removed: true });
    }
    var transfer = index_1.asperaSdk.httpGatewayTransferStore.get(id);
    if (transfer) {
        index_1.asperaSdk.httpGatewayTransferStore.delete(id);
        return Promise.resolve({ removed: true });
    }
    else {
        return Promise.reject((0, helpers_1.generateErrorBody)(messages_1.messages.removeTransferFailed, { reason: 'Not found' }));
    }
};
exports.httpRemoveTransfer = httpRemoveTransfer;
/**
 * Get the list of http gateway transfers
 *
 * @returns list of HTTP Gateway
 */
var httpGetAllTransfers = function () {
    if (index_1.asperaSdk.useOldHttpGateway) {
        return (0, http_gateway_sdk_js_1.getAllTransfers)().transfers;
    }
    return Array.from(index_1.asperaSdk.httpGatewayTransferStore.values());
};
exports.httpGetAllTransfers = httpGetAllTransfers;
/**
 * Get a HTTP Gateway transfer by ID
 *
 * @returns a transfer or null
 */
var httpGetTransfer = function (id) {
    if (index_1.asperaSdk.useOldHttpGateway) {
        return (0, http_gateway_sdk_js_1.getTransferById)(id);
    }
    return index_1.asperaSdk.httpGatewayTransferStore.get(id);
};
exports.httpGetTransfer = httpGetTransfer;
/**
 * Create HTML input element for file picking
 */
var createHtmlInputElement = function () {
    var element = window.document.createElement('input');
    element.type = 'file';
    element.style = 'display: none;';
    window.document.body.appendChild(element);
    return element;
};
exports.createHtmlInputElement = createHtmlInputElement;
/**
 * Handle drop events and store files for HTTP Gateway
 * This works on top of desktop.
 */
var handleHttpGatewayDrop = function (items, callback, event) {
    var files = [];
    var callbackCount = 0;
    var callbackFinishCount = 0;
    var finalCallback = function () {
        if (callbackFinishCount >= callbackCount) {
            var finalFiles = files.map(function (file) {
                index_1.asperaSdk.httpGatewaySelectedFiles.set(file.name, file);
                return {
                    lastModified: file.lastModified,
                    name: file.name,
                    size: file.size,
                    type: file.type
                };
            });
            callback({ event: event, files: { dataTransfer: { files: finalFiles } } });
        }
    };
    var traverse = function (item) {
        if (item.isFile) {
            item.file(function (file) {
                files.push(file);
                callbackFinishCount++;
                finalCallback();
            });
        }
        else if (item.isDirectory) {
            var dirReader = item.createReader();
            dirReader.readEntries(function (entries) {
                for (var k = 0; k < entries.length; k++) {
                    callbackCount++;
                    traverse(entries[k]);
                }
            });
            callbackFinishCount++;
        }
        else {
            callbackFinishCount++;
            finalCallback();
        }
    };
    for (var i = 0; i < items.length; i++) {
        var item = items[i].webkitGetAsEntry();
        if (item) {
            callbackCount++;
            traverse(item);
        }
    }
};
exports.handleHttpGatewayDrop = handleHttpGatewayDrop;
/**
 * Open native browser file or folder picker for files
 *
 * @param options - File picker options
 * @param folder - Indicate if choosing folders
 *
 * @returns Promise that resolves with info about the files picked
 */
var httpGatewaySelectFileFolderDialog = function (options, folder) {
    if (index_1.asperaSdk.useOldHttpGateway) {
        return (folder ? (0, http_gateway_sdk_js_1.getFoldersForUploadPromise)((options === null || options === void 0 ? void 0 : options.http_gateway_v2_transfer_id) || '') : (0, http_gateway_sdk_js_1.getFilesForUploadPromise)((options === null || options === void 0 ? void 0 : options.http_gateway_v2_transfer_id) || ''));
    }
    var _a = (0, helpers_1.generatePromiseObjects)(), promise = _a.promise, rejecter = _a.rejecter, resolver = _a.resolver;
    var element = (0, exports.createHtmlInputElement)();
    element.multiple = !!(options === null || options === void 0 ? void 0 : options.multiple);
    if (folder) {
        element.webkitdirectory = true;
    }
    element.oncancel = function () {
        rejecter({ debugData: { code: -32002, message: messages_1.messages.filePickerCancel } });
    };
    element.onchange = function () {
        var returnFiles = [];
        for (var i = 0; i < element.files.length; i++) {
            var file = element.files[i];
            returnFiles.push(file);
            index_1.asperaSdk.httpGatewaySelectedFiles.set(file.name, file);
        }
        resolver({
            dataTransfer: {
                files: returnFiles.map(function (file) {
                    return {
                        size: file.size,
                        lastModified: file.lastModified,
                        name: file.webkitRelativePath || file.name,
                        type: file.type,
                    };
                })
            }
        });
    };
    element.click();
    return promise;
};
exports.httpGatewaySelectFileFolderDialog = httpGatewaySelectFileFolderDialog;
/**
 * Get a generic transfer object for HTTP Gateway transfers.
 *
 * @param transferSpec - TransferSpec being provided for the HTTP Gateway transfer
 *
 * @returns a transfer object to track status and send to consumers
 */
var getSdkTransfer = function (transferSpec) {
    return {
        uuid: (0, helpers_1.randomUUID)(),
        transfer_spec: transferSpec,
        current_file: '',
        add_time: new Date().toISOString(),
        file_counts: {
            attempted: 0,
            completed: 0,
            failed: 0,
            skipped: 0,
        },
        end_time: '',
        explorer_path: '',
        status: 'queued',
        bytes_written: 0,
        bytes_expected: 0,
        calculated_rate_kbps: 0,
        elapsed_usec: 0,
        percentage: 0,
        title: '',
        remaining_usec: 0,
        httpGatewayTransfer: true,
        httpDownloadExternalHandle: false,
    };
};
exports.getSdkTransfer = getSdkTransfer;
/**
 * Send a transfer update through the SDK
 *
 * @param transfer - Transsfer object to send to consumers
 */
var sendTransferUpdate = function (transfer) {
    index_1.asperaSdk.httpGatewayTransferStore.set(transfer.uuid, transfer);
    index_1.asperaSdk.activityTracking.handleTransferActivity({
        type: 'transferUpdated',
        data: { transfers: [transfer] },
    });
};
exports.sendTransferUpdate = sendTransferUpdate;
/**
 * Try to parse and get a useful string from API calls for HTTP Gateway
 *
 * @param error - Error from API call for Gateway
 *
 * @returns a string to use for errors
 */
var getMessageFromError = function (error) {
    var data = (0, helpers_1.safeJsonParse)(error);
    var message = messages_1.messages.httpNetworkFail;
    var code = 500;
    if (data && typeof data === 'object') {
        message = data.message || data.description || messages_1.messages.httpNetworkFail;
        code = data.code || 500;
    }
    else if (error && typeof error === 'object') {
        message = error.message || error.description || messages_1.messages.httpNetworkFail;
        code = error.code || 500;
    }
    else if (typeof error === 'string') {
        message = error;
    }
    return {
        message: message,
        code: code,
    };
};
exports.getMessageFromError = getMessageFromError;
var base64Encoding = function (jsonString) {
    var bytes = new TextEncoder().encode(jsonString);
    var binString = Array.from(bytes, function (byte) {
        return String.fromCodePoint(byte);
    }).join('');
    return btoa(binString);
};
exports.base64Encoding = base64Encoding;
